import { render, staticRenderFns } from "./SciencePlusAvailability.vue?vue&type=template&id=464ee0ea"
import script from "./SciencePlusAvailability.vue?vue&type=script&lang=js"
export * from "./SciencePlusAvailability.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports